"use client";

import { useTranslator } from "~/i18n/provider";
import { useCartContext } from "~/lib/cart/use-cart";

/**
 * P2-01 · Header cart control. Shows a count badge only when the cart has
 * items (design: "0 · no badge"). P4-02: clicking opens the mini-cart drawer
 * (still emits the analytics event). Uses the non-throwing cart context so it
 * renders safely even outside the provider (badge 0, click no-op).
 */
export function CartButton() {
  const cart = useCartContext();
  const t = useTranslator();
  const count = cart?.count ?? 0;

  return (
    <button
      type="button"
      // P8-01D · Plural form comes from the language's CLDR rules, not a
      // `count === 1` ternary — French treats 0 as singular, Arabic has six
      // forms, and neither survives a hard-coded English branch.
      aria-label={t("nav.cartLabel", { count })}
      onClick={() => {
        cart?.open();
      }}
      className="relative rounded-md p-2 text-fg hover:bg-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <path d="M6 7h12l-1.2 11.2a2 2 0 0 1-2 1.8H9.2a2 2 0 0 1-2-1.8L6 7Z" />
        <path d="M9 7V6a3 3 0 0 1 6 0v1" />
      </svg>
      {count > 0 && (
        <span
          aria-hidden="true"
          className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-none text-primary-fg"
        >
          {count}
        </span>
      )}
    </button>
  );
}
